import { createRoot } from 'react-dom/client'

// Catch global errors early
window.addEventListener('error', (e) => {
  console.error('[GLOBAL_ERROR]', e.error)
})
window.addEventListener('unhandledrejection', (e) => {
  console.error('[UNHANDLED_REJECTION]', e.reason)
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

// Dynamic import to handle any module loading errors gracefully
const startApp = async () => {
  try {
    const AppModule = await import('./App')
    const App = AppModule.default
    const root = createRoot(rootElement)
    root.render(<App />)
  } catch (e) {
    console.error('[APP_LOAD_ERROR]', e)
    rootElement.innerHTML = `
      <div style="padding: 20px; color: #ef4444; font-family: monospace; background: #0f172a; min-height: 100vh;">
        <h1>Application failed to start</h1>
        <pre style="margin-top: 10px; color: #f8fafc;">${e instanceof Error ? e.message : String(e)}</pre>
        <pre style="margin-top: 10px; color: #94a3b8;">${e instanceof Error ? e.stack : ''}</pre>
      </div>
    `
  }
}

startApp()
